import Vue from 'vue'
import iView from 'iview'
import locale from 'iview/dist/locale/zh-TW'

Vue.use(iView, { locale })

import './apcs_theme.less'
